<form [formGroup]="terminForm" (ngSubmit)="speichern()">
    <h2 mat-dialog-title>{{ termin ? 'Edit' : 'Neuer' }} Termin</h2>
    <mat-dialog-content class="flex-container">
        <div class="flex-row flex-wrap gap-10" style="margin-top: 10px" data-cy="KalenderEditRow1">
            <mat-form-field class="flex-grow flexbase-100">
                <mat-label>Kalender</mat-label>
                <mat-select formControlName="kalender_id" data-cy="kalenderZuordnung">
                    @for (k of kalender; track i; let i = $index) {
                        <mat-option [value]="k.id" [attr.data-cy]="'kalenderZuordnung-' + (i + 1)">
                            {{ k.titel }}
                            @if (k.oeffentlich) {
                                <mat-icon>public</mat-icon>
                            }
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field class="flex-grow flexbase-100">
                <mat-label>Betreff</mat-label>
                <input matInput placeholder="Ex. Betreff" formControlName="betreff" data-cy="kalenderBetreff" />
            </mat-form-field>

            <mat-form-field data-cy="kalenderOrt" class="flex-grow flexbase-100">
                <mat-label><mat-icon>place</mat-icon>Ort</mat-label>
                <input matInput placeholder="Ex. Bootshaus Kanu Klub Mühlheim" formControlName="ort" />
            </mat-form-field>

            <!-- Datum AB -->
            <mat-form-field data-cy="kalenderDatumAb" class="flex-grow flexbase-50">
                <mat-label><mat-icon>event</mat-icon>Termin Datum (Start)</mat-label>
                <input matInput [matDatepicker]="datumAbPicker" formControlName="datum" />
                <mat-datepicker-toggle matSuffix [for]="datumAbPicker"></mat-datepicker-toggle>
                <mat-datepicker #datumAbPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field data-cy="kalenderZeitAb" class="flex-grow flexbase-50">
                <mat-label><mat-icon>schedule</mat-icon>Zeit (Start)</mat-label>
                <input matInput [matTimepicker]="timepicker" [formControl]="zeit_ab" />
                <mat-timepicker #timepicker />
                <mat-timepicker-toggle [for]="timepicker" matSuffix />
            </mat-form-field>

            <!-- Datum BIS -->
            <mat-form-field data-cy="kalenderDatumBis" class="flex-grow flexbase-50">
                <mat-label><mat-icon>event</mat-icon>Termin Datum (Ende)</mat-label>
                <input matInput [matDatepicker]="datumBisPicker" formControlName="datum_bis" />
                <mat-datepicker-toggle matSuffix [for]="datumBisPicker"></mat-datepicker-toggle>
                <mat-datepicker #datumBisPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field data-cy="kalenderZeitBis" class="flex-grow flexbase-50">
                <mat-label><mat-icon>schedule</mat-icon>Zeit (Ende)</mat-label>
                <input matInput [matTimepicker]="timepicker_bis" [formControl]="zeit_bis" />
                <mat-timepicker #timepicker_bis />
                <mat-timepicker-toggle [for]="timepicker_bis" matSuffix />
            </mat-form-field>

            <mat-form-field class="flex-grow flexbase-100">
                <mat-label>Beschreibung</mat-label>
                <textarea
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="2"
                    placeholder="Ex. Text mit Inhalt"
                    formControlName="beschreibung"
                    data-cy="kalenderInhalt"></textarea>
            </mat-form-field>

            @if (!termin) {
                <mat-form-field data-cy="wochentageSelect" class="flex-grow flexbase-100">
                    <mat-select
                        id="entry-dialog-wochentage-input"
                        placeholder="Wochentage *"
                        formControlName="weekDays"
                        #weekDaySelection
                        multiple>
                        <!-- eslint-disable-next-line -->
                        <mat-select-trigger>{{ weekDaysToFormFieldText() }}</mat-select-trigger>
                        @for (weekDay of weekDays; track $index) {
                            <mat-option id="entry-dialog-wochentage-day-input" [value]="weekDay">
                                {{ weekDay.displayValue }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }

            <!-- <mat-form-field class="flex-grow flexbase-100">
                <mat-label>Teilnehmer</mat-label>
                <input matInput placeholder="Ex. Alle" formControlName="teilnehmer" data-cy="kalenderBetreff" />
            </mat-form-field> -->

            <mat-form-field class="flex-grow flexbase-100">
                <mat-label>Teilnehmer:</mat-label>
                <mat-select formControlName="teilnehmer_grp" data-cy="teilnehmer_grp" multiple>
                    <mat-option [value]="'alle'" data-cy="grp-alle">Alle</mat-option>
                    @for (grp of gruppen; track $index) {
                        <mat-option [value]="grp.id" [attr.data-cy]="'grp-'+grp.id">{{ grp.title }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-slide-toggle class="flex-grow flexbase-100" formControlName="einladung" data-cy="kalenderEinladung">
                Beim Speichern des Termins werden Einladungen verschickt
            </mat-slide-toggle>
            <mat-slide-toggle class="flex-grow flexbase-100" formControlName="anmeldungen" data-cy="kalenderAnmeldung">
                Anmeldungen für diesen Termin sind möglich
            </mat-slide-toggle>
            <mat-slide-toggle class="flex-grow flexbase-100" formControlName="anmeldungen_vielleicht">
                Antwort "vielleicht" erlauben
            </mat-slide-toggle>
            <!-- <mat-form-field class="flex-grow flexbase-100">
                <mat-label>An-/Abmeldungen sind:</mat-label>
                <mat-select formControlName="anmeldungen_bis">
                    <mat-option [value]="-1">bis Terminende möglich</mat-option>
                    <mat-option [value]="0">bis Terminbeginn möglich</mat-option>
                    <mat-option [value]="5">bis 5 Minuten vor Terminbeginn möglich</mat-option>
                    <mat-option [value]="10">bis 10 Minuten vor Terminbeginn möglich</mat-option>
                    <mat-option [value]="15">bis 15 Minuten vor Terminbeginn möglich</mat-option>
                    <mat-option [value]="30">bis 30 Minuten vor Terminbeginn möglich</mat-option>
                    <mat-option [value]="60">bis 1 Stunde vor Terminbeginn möglich</mat-option>
                    <mat-option [value]="120">bis 2 Stunden vor Terminbeginn möglich</mat-option>
                    <mat-option [value]="180">bis 3 Stunden vor Terminbeginn möglich</mat-option>
                    <mat-option [value]="360">bis 6 Stunden vor Terminbeginn möglich</mat-option>
                    <mat-option [value]="540">bis 9 Stunden vor Terminbeginn möglich</mat-option>
                    <mat-option [value]="720">bis 12 Stunden vor Terminbeginn möglich</mat-option>
                    <mat-option [value]="480">bis 18 Stunden vor Terminbeginn möglich</mat-option>
                    <mat-option [value]="1440">bis 1 Tag vor Terminbeginn möglich</mat-option>
                    <mat-option [value]="2880">bis 2 Tage vor Terminbeginn möglich</mat-option>
                    <mat-option [value]="4320">bis 3 Tage vor Terminbeginn möglich</mat-option>
                    <mat-option [value]="10080">bis 1 Woche vor Terminbeginn möglich</mat-option>
                </mat-select>
            </mat-form-field> -->
            
            <mat-form-field class="flex-grow flexbase-100">
                <mat-label>Anzeige Teilnehmer:</mat-label>
                <mat-select formControlName="anzeige_teilnehmer" data-cy="anzeige_teilnehmer">
                    <!-- <mat-option [value]="'voll'" data-cy="anzeige_teilnehmer-voll"
                        >Vollständige Anzeige (An-/Abmeldungen einzelner Teilnehmer anzeigen)</mat-option
                    > -->
                    <mat-option [value]="'anzahl'" data-cy="anzeige_teilnehmer-anzahl"
                        >Nur Teilnehmerzahlen (Anzahl der An-/Abmeldungen anzeigen)</mat-option
                    >
                    <mat-option [value]="'keine'" data-cy="anzeige_teilnehmer-keine"
                        >Keine Anzeige (Keine Information über An-Abmeldungen anzeigen)
                    </mat-option>
                </mat-select>
            </mat-form-field> 
           
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button (click)="onCancel()" type="button" data-cy="closeBtn">Schließen</button>
        <button mat-button type="submit" data-cy="kalenderSpeichernBtn" [disabled]="!terminForm.valid">
            <mat-icon>save</mat-icon> Speichern
        </button>
    </mat-dialog-actions>
</form>
